var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCalendar = function SvgCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h32v32H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m14.6 24.467-4.733-4.734L11.8 17.8l2.8 2.8 5.6-5.6 1.933 1.933-7.533 7.534Zm-7.933 4.866a2.568 2.568 0 0 1-1.884-.783A2.568 2.568 0 0 1 4 26.667V8c0-.733.261-1.361.783-1.883a2.568 2.568 0 0 1 1.884-.784H8V2.667h2.667v2.666h10.666V2.667H24v2.666h1.333c.734 0 1.361.261 1.884.784.522.522.783 1.15.783 1.883v18.667c0 .733-.261 1.36-.783 1.883a2.568 2.568 0 0 1-1.884.783H6.667Zm0-2.666h18.666V13.333H6.667v13.334Zm0-16h18.666V8H6.667v2.667Z",
    fill: "#A05600"
  }))));
};
export default SvgCalendar;